import { createSlice } from "@reduxjs/toolkit";
import { getVideos, deleteVideo } from "./_videoAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isDeleting: false,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
  pageSize: 100,
};

export const videoList = createSlice({
  name: "videoList",
  initialState: initialState,
  reducers: {
    setVideoPageSize: (state, { payload }) => {
      state.pageSize = Number(payload);
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getVideos.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getVideos.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getVideos.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
      .addCase(deleteVideo.pending, (state) => {
        state.isDeleting = true;
      })
      .addCase(deleteVideo.fulfilled, (state) => {
        state.isDeleting = false;
      })
      .addCase(deleteVideo.rejected, (state) => {
        state.isDeleting = false;
      })
  },
});

export const { setVideoPageSize } = videoList.actions;
